<template>
  <div class="portal-dashboard pa-4">
    <v-row v-if="loading">
      <v-col cols="12" class="text-center py-8">
        <v-progress-circular indeterminate color="#ff5722" size="48" />
      </v-col>
    </v-row>

    <template v-else-if="dashboard">
      <!-- Hero salut angajat -->
      <div class="hero mb-5">
        <div class="hero-av">{{ heroInitiale }}</div>
        <div class="hero-txt">
          <div class="hero-hi">Bună ziua,</div>
          <div class="hero-name">{{ dashboard.NumeAngajat }}</div>
          <div class="hero-sub">
            <v-icon size="14" class="mr-1">mdi-office-building-outline</v-icon>{{ dashboard.Departament || '—' }}
            <span class="hero-dot">•</span>
            <v-icon size="14" class="mr-1">mdi-badge-account-outline</v-icon>{{ dashboard.Functie || '—' }}
          </div>
        </div>
        <div class="hero-date">
          <v-icon size="16" class="mr-1">mdi-calendar-today</v-icon>{{ aziStr }}
        </div>
      </div>

      <!-- Cards KPI -->
      <v-row class="kpi-row mb-4">
        <v-col cols="12" sm="6" md="3">
          <v-card class="kpi-card" color="green-lighten-5" elevation="2" rounded="xl">
            <v-card-text class="text-center py-2">
              <v-icon size="22" color="green-darken-2" class="mb-2">mdi-umbrella-beach</v-icon>
              <div class="kpi-value text-green-darken-2">{{ dashboard.ZileCODisponibile }}</div>
              <div class="kpi-label">Zile CO disponibile</div>
              <div class="kpi-sub text-medium-emphasis">Folosite: {{ dashboard.ZileCOFolosite }}</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="kpi-card" :color="dashboard.CereriConcediuInAsteptare > 0 ? 'amber-lighten-5' : 'grey-lighten-5'" elevation="2" rounded="xl">
            <v-card-text class="text-center py-2">
              <v-icon size="22" :color="dashboard.CereriConcediuInAsteptare > 0 ? 'amber-darken-2' : 'grey'" class="mb-2">mdi-clock-outline</v-icon>
              <div class="kpi-value" :class="dashboard.CereriConcediuInAsteptare > 0 ? 'text-amber-darken-2' : 'text-grey'">{{ dashboard.CereriConcediuInAsteptare }}</div>
              <div class="kpi-label">Cereri în așteptare</div>
              <div class="kpi-sub text-medium-emphasis">Concedii</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="kpi-card" :color="dashboard.TicheteInAsteptare > 0 ? 'blue-lighten-5' : 'grey-lighten-5'" elevation="2" rounded="xl">
            <v-card-text class="text-center py-2">
              <v-icon size="22" :color="dashboard.TicheteInAsteptare > 0 ? 'blue-darken-2' : 'grey'" class="mb-2">mdi-ticket-outline</v-icon>
              <div class="kpi-value" :class="dashboard.TicheteInAsteptare > 0 ? 'text-blue-darken-2' : 'text-grey'">{{ dashboard.TicheteInAsteptare }}</div>
              <div class="kpi-label">Tichete deschise</div>
              <div class="kpi-sub text-medium-emphasis">HR</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="kpi-card" :color="dashboard.PontajPlecareLipsaAzi ? 'red-lighten-5' : 'green-lighten-5'" elevation="2" rounded="xl">
            <v-card-text class="text-center py-2">
              <v-icon size="22" :color="dashboard.PontajPlecareLipsaAzi ? 'red-darken-2' : 'green-darken-2'" class="mb-2">
                {{ dashboard.PontajPlecareLipsaAzi ? 'mdi-door-open' : 'mdi-check-circle' }}
              </v-icon>
              <div class="kpi-value" :class="dashboard.PontajPlecareLipsaAzi ? 'text-red-darken-2' : 'text-green-darken-2'">
                {{ dashboard.PontajPlecareLipsaAzi ? '!' : 'OK' }}
              </div>
              <div class="kpi-label">Pontaj azi</div>
              <div class="kpi-sub text-medium-emphasis">
                {{ dashboard.PontajPlecareLipsaAzi ? 'Plecare lipsă' : 'Complet' }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Colegi în CO astăzi (ca în dashboard-ul legacy) -->
        <v-col cols="12" sm="6" md="3">
          <v-card class="kpi-card" color="teal-lighten-5" elevation="2" rounded="xl">
            <v-card-text class="text-center py-2">
              <v-icon size="22" color="teal-darken-2" class="mb-2">mdi-account-group</v-icon>
              <div class="kpi-value text-teal-darken-2">{{ dashboard.ColegiInCOAstazi }}</div>
              <div class="kpi-label">Colegi în CO astăzi</div>
              <div class="kpi-sub text-medium-emphasis">{{ dashboard.VedeToataFirma ? 'Toată firma' : 'Departamentul tău' }}</div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Metrică manager: cereri de aprobat -->
        <v-col v-if="dashboard.EsteManager" cols="12" sm="6" md="3">
          <v-card class="kpi-card" :color="dashboard.CereriDeAprobat > 0 ? 'orange-lighten-5' : 'grey-lighten-5'"
                  elevation="2" rounded="xl" style="cursor:pointer"
                  @click="$router.push({ name: 'PortalAprobari' })">
            <v-card-text class="text-center py-2">
              <v-icon size="22" :color="dashboard.CereriDeAprobat > 0 ? 'orange-darken-2' : 'grey'" class="mb-2">mdi-clipboard-check-outline</v-icon>
              <div class="kpi-value" :class="dashboard.CereriDeAprobat > 0 ? 'text-orange-darken-2' : 'text-grey'">{{ dashboard.CereriDeAprobat }}</div>
              <div class="kpi-label">Cereri de aprobat</div>
              <div class="kpi-sub text-medium-emphasis">Ca manager</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Acțiuni rapide -->
      <v-row>
        <v-col cols="12" sm="6" md="3" v-for="act in actiuniRapide" :key="act.route">
          <v-card class="action-card" elevation="1" rounded="xl" @click="$router.push({ name: act.route })" :ripple="true" style="cursor:pointer">
            <v-card-text class="d-flex align-center pa-4">
              <v-avatar :color="act.color" size="44" class="mr-3">
                <v-icon color="white" size="22">{{ act.icon }}</v-icon>
              </v-avatar>
              <div>
                <div class="action-title">{{ act.title }}</div>
                <div class="action-sub text-medium-emphasis text-caption">{{ act.sub }}</div>
              </div>
              <v-spacer />
              <v-icon color="grey-lighten-1">mdi-chevron-right</v-icon>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Secțiunea de jos: Istoric concedii + Colegi în CO + Calendar echipă (ca în legacy) -->
      <v-row class="mt-2">
        <v-col cols="12" md="6">
          <v-card class="section-card" elevation="1" rounded="xl">
            <div class="section-header"><v-icon size="18" class="mr-2" color="#ff5722">mdi-history</v-icon>Istoric concedii</div>
            <v-table density="compact">
              <thead><tr><th>An</th><th>Tip</th><th class="text-right">Zile</th></tr></thead>
              <tbody>
                <tr v-for="(it, i) in istoric" :key="i">
                  <td class="font-weight-bold">{{ it.An }}</td>
                  <td>{{ it.Tip || '—' }}</td>
                  <td class="text-right font-weight-bold text-red-darken-1">{{ it.Zile }}</td>
                </tr>
                <tr v-if="!istoric.length"><td colspan="3" class="text-center text-medium-emphasis py-3">Fără date</td></tr>
              </tbody>
            </v-table>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card class="section-card" elevation="1" rounded="xl">
            <div class="section-header">
              <v-icon size="18" class="mr-2" color="green-darken-1">mdi-account-group</v-icon>Colegi în CO astăzi
              <v-chip size="x-small" color="green-darken-1" class="ml-2">{{ colegiAzi.length }}</v-chip>
            </div>
            <div class="colegi-list">
              <div v-for="(c, i) in colegiAzi" :key="i" class="coleg-item"><span class="dot"></span>{{ c }}</div>
              <div v-if="!colegiAzi.length" class="text-center text-medium-emphasis py-3">Niciun coleg în CO astăzi</div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card class="section-card" elevation="1" rounded="xl">
            <div class="section-header"><v-icon size="18" class="mr-2" color="#ff5722">mdi-calendar-month</v-icon>Planificare concedii — toată firma</div>
            <CalendarConcedii :items="calendarItems" :holidays="sarbatori" :initial-date="calendarDate" />
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card class="section-card" elevation="1" rounded="xl">
            <div class="section-header"><v-icon size="18" class="mr-2" color="purple-darken-1">mdi-home-account</v-icon>Munca de acasă (WFH) — toată firma</div>
            <CalendarConcedii :items="wfhItems" :holidays="sarbatori" :initial-date="calendarDate" />
          </v-card>
        </v-col>
      </v-row>
    </template>

    <v-alert v-else-if="error" type="error" variant="tonal">{{ error }}</v-alert>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CalendarConcedii from './components/CalendarConcedii.vue'
import PORTAL_Dashboard from '@/services/Portal/PORTAL_Dashboard'
import PORTAL_CereriConcedii from '@/services/Portal/PORTAL_CereriConcedii'

export default defineComponent({
  name: 'PortalDashboard',
  components: { CalendarConcedii },
  data() {
    return {
      loading: false,
      error: '',
      dashboard: null as any,
      istoric: [] as any[],
      colegiAzi: [] as string[],
      calendarItems: [] as any[],
      wfhItems: [] as any[],
      sarbatori: [] as any[],
      calendarDate: new Date(),
      actiuniRapide: [
        { title: 'Cereri concediu', sub: 'Depune sau urmărește', icon: 'mdi-umbrella-beach', color: 'green-darken-1', route: 'PortalCereriConcediu' },
        { title: 'Tichete HR', sub: 'Adeverințe, cereri', icon: 'mdi-ticket', color: 'blue-darken-1', route: 'PortalTichete' },
        { title: 'Pontaj', sub: 'Vizualizare lunar', icon: 'mdi-clock', color: 'purple-darken-1', route: 'PortalPontaj' },
        { title: 'Profil', sub: 'Date personale', icon: 'mdi-account', color: 'orange-darken-1', route: 'PortalProfil' },
      ]
    }
  },
  computed: {
    heroInitiale(): string {
      const n = (this.dashboard?.NumeAngajat || '').trim();
      const p = n.split(/\s+/).filter(Boolean);
      return ((p[0]?.[0] || '') + (p.length > 1 ? p[p.length - 1][0] : '')).toUpperCase() || '?';
    },
    aziStr(): string {
      const zile = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
      const luni = ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'noi', 'dec'];
      const d = new Date();
      return `${zile[d.getDay()]}, ${d.getDate()} ${luni[d.getMonth()]} ${d.getFullYear()}`;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      const resp = await PORTAL_Dashboard.get();
      this.dashboard = resp.data;
    } catch (e: any) {
      this.error = 'Nu s-au putut încărca datele dashboard-ului.';
    } finally {
      this.loading = false;
    }

    // Secțiunea de jos (istoric + colegi + calendar) — independentă, nu blochează dashboard-ul.
    try {
      const cal = await PORTAL_Dashboard.getCalendar();
      this.istoric = cal.data.Istoric || [];
      this.colegiAzi = cal.data.ColegiInCOAzi || [];
      const rawItems = cal.data.Calendar || [];
      this.calendarItems = rawItems.map((x: any) => {
        const nume = (x.Angajat || '').trim() || '—';
        const parti = nume.split(/\s+/).filter(Boolean);
        const initiale = (parti[0]?.[0] || '') + (parti.length > 1 ? parti[parti.length - 1][0] : '');
        return {
          nume,
          initiale: initiale.toUpperCase() || '—',
          tip: x.TipConcediu || 'CO',
          stare: x.Stare || '1',
          start: new Date(x.DataInceput),
          end: new Date(x.DataSfarsit),
        };
      });
      const mapItem = (x: any) => {
        const nume = (x.Angajat || '').trim() || '—';
        const parti = nume.split(/\s+/).filter(Boolean);
        const initiale = (parti[0]?.[0] || '') + (parti.length > 1 ? parti[parti.length - 1][0] : '');
        return {
          nume, initiale: initiale.toUpperCase() || '—',
          tip: x.TipConcediu || 'CO', stare: x.Stare || '1',
          start: new Date(x.DataInceput), end: new Date(x.DataSfarsit),
        };
      };
      this.wfhItems = (cal.data.Wfh || []).map(mapItem);
      try { this.sarbatori = (await PORTAL_CereriConcedii.getSarbatoriLegale()).data || []; } catch { /* */ }

      // Deschide calendarul pe luna cu cei mai mulți angajați în concediu (ca să vezi imediat activitate).
      if (rawItems.length) {
        const perLuna: Record<string, Set<string>> = {};
        for (const it of rawItems) {
          const cheie = (it.DataInceput || '').slice(0, 7); // YYYY-MM
          if (!cheie) continue;
          (perLuna[cheie] = perLuna[cheie] || new Set()).add(it.Angajat || '');
        }
        const lunaTop = Object.entries(perLuna).sort((a, b) => b[1].size - a[1].size)[0];
        if (lunaTop) {
          const [an, luna] = lunaTop[0].split('-').map(Number);
          this.calendarDate = new Date(an, luna - 1, 1);
        }
      }
    } catch (e) {
      // secțiunea de jos rămâne goală dacă datele nu pot fi încărcate
    }
  }
})
</script>

<style scoped>
.hero {
  display: flex; align-items: center; gap: 14px;
  background: linear-gradient(100deg, #ff5722 0%, #ff8a5c 100%);
  border-radius: 14px; padding: 12px 18px; color: #fff;
  box-shadow: 0 6px 18px rgba(255, 87, 34, 0.25);
}
.hero-av {
  width: 46px; height: 46px; border-radius: 12px; flex-shrink: 0;
  background: rgba(255, 255, 255, 0.22);
  display: flex; align-items: center; justify-content: center;
  font-size: 17px; font-weight: 800; letter-spacing: 0.5px;
}
.hero-hi { font-size: 0.72rem; opacity: 0.9; }
.hero-name { font-size: 1.15rem; font-weight: 800; line-height: 1.15; }
.hero-sub { font-size: 0.76rem; opacity: 0.95; margin-top: 2px; display: flex; align-items: center; flex-wrap: wrap; }
.hero-dot { margin: 0 8px; opacity: 0.6; }
.hero-date {
  margin-left: auto; align-self: flex-start;
  background: rgba(255, 255, 255, 0.18); border-radius: 20px;
  padding: 6px 14px; font-size: 0.8rem; font-weight: 600; white-space: nowrap;
  display: flex; align-items: center;
}
@media (max-width: 700px) { .hero-date { display: none; } }
.kpi-card { transition: transform .15s, box-shadow .15s; }
.kpi-card:hover { transform: translateY(-3px); box-shadow: 0 8px 24px rgba(0,0,0,0.1) !important; }
/* Toate KPI-urile pe un singur rând, egale și compacte */
.kpi-row { flex-wrap: wrap; }
.kpi-row :deep([class*="v-col-"]) { flex: 1 1 0 !important; max-width: none !important; min-width: 140px; padding: 6px !important; }
.kpi-value { font-size: 1.35rem; font-weight: 800; line-height: 1; margin-bottom: 0.15rem; }
.kpi-label { font-size: 0.78rem; font-weight: 700; color: #334155; line-height: 1.1; }
.kpi-sub { font-size: 0.68rem; margin-top: 0.15rem; }
.action-title { font-size: 0.9rem; font-weight: 600; color: #1a202c; }
.action-card { transition: all 0.2s; }
.action-card:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,0,0,0.1) !important; }

.section-card { overflow: hidden; }
.section-header {
  display: flex; align-items: center;
  font-size: 0.9rem; font-weight: 700; color: #1e293b;
  padding: 12px 16px; border-bottom: 1px solid #f1f5f9;
}
.colegi-list { max-height: 220px; overflow-y: auto; padding: 8px 16px; }
.coleg-item { display: flex; align-items: center; gap: 8px; padding: 6px 0; font-size: 0.85rem; color: #334155; border-bottom: 1px solid #f8f9fc; }
.coleg-item .dot { width: 7px; height: 7px; border-radius: 50%; background: #059669; }

/* ---- Finisaj general ecran ---- */
.portal-dashboard { background: #f6f7fb; min-height: 100%; }
.kpi-card { border: 1px solid rgba(15, 23, 42, 0.05); border-radius: 16px !important; }
.kpi-label { text-transform: uppercase; letter-spacing: 0.4px; }
.section-card { border: 1px solid #edf0f5; border-radius: 16px !important; }
.section-header {
  background: #fcfcfd;
  border-bottom: 1px solid #eef1f6;
  font-size: 0.92rem; font-weight: 800; color: #1e293b;
  padding: 13px 18px; letter-spacing: 0.2px;
}
.action-card { border: 1px solid #edf0f5; border-radius: 16px !important; }
.action-title { font-weight: 700; color: #1e293b; }
/* Tabel Istoric */
.section-card :deep(thead th) {
  font-size: 11px !important; text-transform: uppercase; letter-spacing: 0.4px;
  color: #94a3b8 !important; font-weight: 700; background: #fcfcfd;
}
.section-card :deep(tbody tr:hover) { background: #f8fafc; }
.section-card :deep(tbody td) { font-size: 0.85rem; }
</style>
